import { render, staticRenderFns } from "./DemoView.vue?vue&type=template&id=877df85c&scoped=true&"
import script from "./DemoView.vue?vue&type=script&lang=ts&"
export * from "./DemoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877df85c",
  null
  
)

export default component.exports